import { Chip, Tooltip, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useIsOverflown } from "hooks/useIsOverflown";
import { memo } from "react";

interface OverflowChipTooltipProps {
  label: string;
  placement:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  "data-test-id"?: string;
}

export const useStyles = makeStyles(() =>
  createStyles({
    chip: {
      borderRadius: "4px",
    },
  }),
);

export const OverflowChipTooltip = ({
  label,
  placement,
  "data-test-id": dataTestId,
}: OverflowChipTooltipProps) => {
  const classes = useStyles();
  const { observeElement, isOverflown } = useIsOverflown();

  return (
    <Tooltip
      title={label}
      placement={placement}
      disableHoverListener={!isOverflown}
      data-test-id={dataTestId && `${dataTestId}-tooltip`}
    >
      <Chip
        className={classes.chip}
        label={
          <Typography
            ref={observeElement}
            noWrap
            fontSize={13}
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {label}
          </Typography>
        }
        data-test-id={dataTestId && `${dataTestId}-chip`}
      />
    </Tooltip>
  );
};

export default memo(OverflowChipTooltip);
